export const environment = {
  production: true,
  name: 'prod',
  configFile: '/bmt-ui/assets/env-configs/commercial-config.json',
  configFileFgp: '/bmt-ui/assets/env-configs/fgp-config.json'
};
